'use strict';

angular.module("imagetrend.components").directive("hlpFormBuilderComponent", [
    function() {
        return {
            restrict: "AE",
            scope: {
                component: "=?",
                parentQuestion: "=?",
                parentComponent: "=?",
                formType: "=?",
                sets: "=?",
                elements: "=?",
                form: "=?",
                resultSet: "=?",
                parameters: "=?",
                attachments: "=?",
                inspectionChecklist: "=?"
            },
            controller: [
                "$scope",
                function ($scope) {
                    $scope.calculatedFieldCalculationTypeOptions = [
                        { id: 0, name: "Count" }
                    ];
                    $scope.reimburseLengthTypes = [
                        { id: 'Day', name: 'Day' },
                        { id: 'Week', name: 'Week' },
                        { id: 'Month', name: 'Month' },
                        { id: 'Year', name: 'Year' }
                    ];

                    if ($scope.parameters.contentOptions == null) {
                        $scope.contentTypeOptions = [
                            { id: 0, name: "Text Editor" },
                            { id: 1, name: "Attachment" },
                            { id: 2, name: "PDF Preview" }
                        ];
                    } else {
                        $scope.contentTypeOptions =
                            $scope.parameters.contentOptions;
                    }
                    $scope.componentTypeInit = function (component, types) {
                        types.forEach(function(type) {
                            if (
                                type.code == "form_element" &&
                                component.component_type_id != type.id &&
                                ($scope.elements == null ||
                                    $scope.elements.length == 0)
                            ) {
                                updateArray(types, type, true);
                            }
                            else if (type.code === "dataset" && $scope.sets && $scope.sets.length === 0) {
                                // data set withtout sets is only from service inspections, remove option (being used by vehicle inspection though). Exams sets are undefined.
                                types.splice(types.indexOf(type), 1);
                            }
                        });
                        if (
                            component.component_type_id == null &&
                            types.length > 0
                        ) {
                            component.component_type_id = types[0].id;
                            component.component_type = {};
                            types.forEach(function(type) {
                                if (type.id == component.component_type_id) {
                                    component.component_type = type;
                                }
                            });
                        }
                    };

                    $scope.formElementInit = function(
                        component,
                        form_elements
                    ) {
                        if (
                            component.element_id == null &&
                            form_elements.length > 0
                        ) {
                            component.element_id = form_elements[0].id;
                            form_elements.forEach(function(element) {
                                if (element.id == component.element_id) {
                                    component.element_code = element.code;
                                    component.element_instructions =
                                        element.description;
                                }
                            });
                        }
                    };

                    $scope.componentTypeChange = function (component, types) {
                        component.questions = [];
                        component.data_set_id = null;
                        component.component_conditions = [];
                        component.calculation_type = null;

                        if (component.component_type_id == null) {
                            component.component_type = {};
                        } else {
                            types.forEach(function(type) {
                                if (type.id == component.component_type_id) {
                                    component.component_type = type;
                                }
                            });
                            if (component.initialQuestions != null
                                && component.initialQuestions[component.component_type_id] != null) {
                                component.questions = component.initialQuestions[component.component_type_id];
                            } else if (component.component_type.code == "calculated_field" && component.initialQuestions[component.component_type_id] == undefined)
                            {
                                component.calculation_type = 0;

                                var calcFieldConditions = {
                                    id: guid(),
                                    and_flag: true,
                                    operator: "=",
                                    left_parenthesis: 0,
                                    right_parenthesis: 0,
                                    sort_order: 1
                                }

                                var question = {
                                    id: guid(),
                                    section_id: component.section_id,
                                    component_id: component.id,
                                    sort_order: component.questions.length,
                                    sub_components: [],
                                    edit: true,
                                    required: false,
                                    vertical: true,
                                    multiple: false,
                                    ssn_setting: 0,
                                    display_blank_zero: false,
                                    file_upload_description: true,
                                    file_upload_existing_docs: false,
                                    disabled: false,
                                    default_value: 0,
                                    label_position: false,
                                    update_from_form: false,
                                    share_files: false,
                                    show_in_grid: false,
                                    masked_setting: false,
                                    showValidation: true,
                                    question_type_id: "b2932f47-8938-4999-92a6-f4a33ee55f8a" //calculated_field
                                }
                                question.question_type = {};
                                question.validation = {};
                                question.validation.validation_type_id = "8bff2877-d993-46a8-a850-751bde002f87"; //numeric
                                question.validation.type_message = "Value must be numeric";

                                component.component_conditions.push(calcFieldConditions);
                                component.questions.push(question);
                            }
                        }
                    };
                            
                    $scope.dataSetInit = function(component, sets) {
                        component.data_points = [];
                        if (component.data_set_id == null && sets.length > 0) {
                            component.data_set_id = sets[0].id;
                        }

                        if (component.data_set_id == null) {
                            component.data_set = {};
                        } else {
                            sets.forEach(function(set) {
                                if (set.id == component.data_set_id) {
                                    component.data_set = angular.copy(set);
                                    if (component.license_category_id == null) {
                                        component.license_category_id =
                                            set.default_license_category_id;
                                    } else {
                                        if (
                                            component.parameters
                                                .orignalLicenseID == null &&
                                            component.parameters.license_id !=
                                                null
                                        ) {
                                            component.parameters.orignalLicenseID =
                                                component.parameters.license_id;
                                        }

                                        component.parameters.license_category_id =
                                            component.license_category_id;

                                        if (
                                            component.data_set
                                                .default_license_category_id ==
                                            component.license_category_id
                                        ) {
                                            component.parameters.license_id =
                                                component.parameters.orignalLicenseID;
                                        } else {
                                            component.parameters.license_id = null;
                                            if (
                                                component.data_set.code ==
                                                "certification"
                                            ) {
                                                component.data_set.data_points
                                                    .slice()
                                                    .reverse()
                                                    .forEach(function(
                                                        point,
                                                        index,
                                                        object
                                                    ) {
                                                        if (
                                                            point.code ==
                                                            "certification_application_type"
                                                        ) {
                                                            component.data_set.data_points.splice(
                                                                object.length -
                                                                    1 -
                                                                    index,
                                                                1
                                                            );
                                                        }
                                                    });
                                            }
                                        }
                                    }

                                    component.data_set.data_points
                                        .slice()
                                        .reverse()
                                        .forEach(function(
                                            point,
                                            index,
                                            object
                                        ) {
                                            if (
                                                component.data_set
                                                    .license_category_specific &&
                                                point.license_category_id !=
                                                    null &&
                                                point.license_category_id !=
                                                    component.license_category_id
                                            ) {
                                                component.data_set.data_points.splice(
                                                    object.length - 1 - index,
                                                    1
                                                );
                                            }
                                        });
                                }
                            });
                            // limit positions
                            component.parameters.limit_position_ids =
                                component.limit_position_ids;
                            component.limit_position_ids_array =
                                component.limit_position_ids == null
                                    ? []
                                    : component.limit_position_ids;
                            // limit certification levels
                            component.parameters.limit_license_level_ids =
                                component.limit_license_level_ids;
                            component.limit_license_level_ids_array =
                                component.limit_license_level_ids == null
                                    ? []
                                    : component.limit_license_level_ids;
                            // service classification filter
                            component.parameters.service_classification_filter_ids =
                                component.service_classification_filter_ids;
                            component.service_classification_filter_ids_array =
                                component.service_classification_filter_ids == null
                                    ? []
                                    : component.service_classification_filter_ids;
                            // limit vehicle types
                            component.parameters.limit_vehicle_type_ids =
                                component.limit_vehicle_type_ids;
                            component.limit_vehicle_type_ids_array =
                                component.limit_vehicle_type_ids == null
                                    ? []
                                    : component.limit_vehicle_type_ids;
                            // limit document types
                            component.parameters.limit_document_type_ids =
                                component.limit_document_type_ids;
                            component.limit_document_type_ids_array =
                                component.limit_document_type_ids == null
                                    ? []
                                    : component.limit_document_type_ids;

                            if (component.questions.length > 0) {
                                component.questions.forEach(function(question) {
                                    component.data_set.data_points.forEach(
                                        function(data_point) {
                                            if (
                                                data_point.id ==
                                                    question.data_point_id &&
                                                data_point.attribute_id ==
                                                    question.attribute_id
                                            ) {
                                                data_point.sort_order =
                                                    question.sort_order;
                                                question.point = data_point;
                                                component.data_points.push(
                                                    data_point
                                                );
                                            }
                                        }
                                    );
                                });
                            } else {
                                component.data_set.data_points.forEach(function(
                                    point
                                ) {
                                    var question = {};

                                    if (point.visible) {
                                        question.id = guid();
                                        question.question_type_id =
                                            point.question_type_id;
                                        question.section_id =
                                            component.section_id;
                                        question.sort_order = point.sort_order;
                                        question.name = point.name;
                                        question.label = point.label;
                                        question.label_position =
                                            typeof $scope.form != "undefined" &&
                                            $scope.form.label_position != null
                                                ? $scope.form.label_position
                                                : true;
                                        question.required = point.required;
                                        question.component_id = component.id;
                                        question.question_type =
                                            point.question_type;
                                        question.service = point.service;
                                        question.method = point.method;
                                        question.select_show =
                                            point.select_show;
                                        question.options = point.options;
                                        question.vertical = true;
                                        question.multiple = false;
                                        question.disabled = false;
                                        question.update_from_form =
                                            point.table_name != null
                                                ? true
                                                : false;
                                        question.share_files = false;
                                        question.ssn_setting = 0;
                                        question.masked_setting = false;
                                        question.file_upload_description = true;
                                        question.show_in_grid =
                                            point.question_type.encrypted ==
                                            true
                                                ? 0
                                                : 1;
                                        question.data_point_id = point.id;
                                        question.data_point_code = point.code;
                                        question.data_point_table_name =
                                            point.table_name;
                                        question.attribute_id =
                                            point.attribute_id;
                                        question.compound_id =
                                            point.compound_id;
                                        question.instruction_text =
                                            point.instruction_text;
                                        question.point = point;

                                        if (
                                            point.name ==
                                                "CTCSS Receive Tone" ||
                                            point.name ==
                                                "CTCSS Transmit Frequency"
                                        ) {
                                            question.validation = {};
                                            question.validation.expression =
                                                "^[0-9]{3}\\.[0-9]{1}$";
                                            question.validation.expression_message =
                                                "Please enter the value in 999.9 format.";
                                        }

                                        component.questions.push(question);
                                        component.data_points.push(point);
                                    }
                                });
                            }
                        }
                    };

                    $scope.dataSetChange = function (component, sets) {
                        component.questions = [];
                        component.data_points = [];

                        if (component.data_set_id == null) {
                            component.data_set = {};
                        } else {
                            sets.forEach(function(set) {
                                if (set.id == component.data_set_id) {
                                    component.data_set = angular.copy(set);
                                    if (component.license_category_id == null) {
                                        component.license_category_id =
                                            set.default_license_category_id;
                                    } else {
                                        if (
                                            component.parameters
                                                .orignalLicenseID == null &&
                                            component.parameters.license_id !=
                                                null
                                        ) {
                                            component.parameters.orignalLicenseID =
                                                component.parameters.license_id;
                                        }

                                        component.parameters.license_category_id =
                                            component.license_category_id;

                                        if (
                                            component.data_set
                                                .default_license_category_id ==
                                            component.license_category_id
                                        ) {
                                            component.parameters.license_id =
                                                component.parameters.orignalLicenseID;
                                        } else {
                                            component.parameters.license_id = null;
                                            if (
                                                component.data_set.code ==
                                                "certification"
                                            ) {
                                                component.data_set.data_points
                                                    .slice()
                                                    .reverse()
                                                    .forEach(function(
                                                        point,
                                                        index,
                                                        object
                                                    ) {
                                                        if (
                                                            point.code ==
                                                            "certification_application_type"
                                                        ) {
                                                            component.data_set.data_points.splice(
                                                                object.length -
                                                                    1 -
                                                                    index,
                                                                1
                                                            );
                                                        }
                                                    });
                                            }
                                        }
                                    }

                                    component.data_set.data_points
                                        .slice()
                                        .reverse()
                                        .forEach(function(
                                            point,
                                            index,
                                            object
                                        ) {
                                            if (
                                                component.data_set
                                                    .license_category_specific &&
                                                point.license_category_id !=
                                                    null &&
                                                point.license_category_id !=
                                                    component.license_category_id
                                            ) {
                                                component.data_set.data_points.splice(
                                                    object.length - 1 - index,
                                                    1
                                                );
                                            }
                                        });
                                    // Update component for service_user_changes
                                    if (component.data_set.code === "service_user_changes") {
                                        component.allow_multiple_groups = true;
                                        component.groups_until_list = 0;
                                    } else {
                                        // revert back to default
                                        component.allow_multiple_groups = false;
                                        component.groups_until_list = 2;
                                    }
                                }
                            });

                            // limit positions
                            component.parameters.limit_position_ids =
                                component.limit_position_ids;
                            component.limit_position_ids_array = component.limit_position_ids_array =
                                component.limit_position_ids == null
                                    ? []
                                    : component.limit_position_ids;
                            // limit certification levels
                            component.parameters.limit_license_level_ids =
                                component.limit_license_level_ids;
                            component.limit_license_level_ids_array = component.limit_license_level_ids_array =
                                component.limit_license_level_ids == null
                                    ? []
                                    : component.limit_license_level_ids;
                            // service classification filters
                            component.parameters.service_classification_filter_ids =
                                component.service_classification_filter_ids;
                            component.service_classification_filter_ids_array = component.service_classification_filter_ids_array =
                                component.service_classification_filter_ids == null
                                    ? []
                                : component.service_classification_filter_ids;
                            // limit vehicle types
                            component.parameters.limit_vehicle_type_ids =
                                component.limit_vehicle_type_ids;
                            component.limit_vehicle_type_ids_array = component.limit_vehicle_type_ids_array =
                                component.limit_vehicle_type_ids == null
                                    ? []
                                    : component.limit_vehicle_type_ids;
                            // limit document types
                            component.parameters.limit_document_type_ids =
                                component.limit_document_type_ids;
                            component.limit_document_type_ids_array = component.limit_document_type_ids_array =
                                component.limit_document_type_ids == null
                                    ? []
                                : component.limit_document_type_ids;
                            // skills
                            component.parameters.skill_question_ids =
                                component.skill_question_ids;
                            component.parameters.skill_show_points =
                                component.skill_show_points;
                            component.parameters.skill_default =
                                component.skill_default;

                            if (
                                component.initialQuestions != null &&
                                component.initialQuestions[
                                    component.component_type_id
                                ] != null
                            ) {
                                component.initialQuestions[
                                    component.component_type_id
                                ].forEach(function(initialQuestion) {
                                    component.data_set.data_points.forEach(
                                        function(data_point) {
                                            if (
                                                data_point.id ==
                                                    initialQuestion.data_point_id &&
                                                data_point.attribute_id ==
                                                    initialQuestion.attribute_id
                                            ) {
                                                data_point.initialFound = true;
                                                data_point.sort_order =
                                                    initialQuestion.sort_order;
                                                initialQuestion.point = data_point;
                                                component.questions.push(
                                                    initialQuestion
                                                );
                                                component.data_points.push(
                                                    data_point
                                                );
                                            }
                                        }
                                    );
                                });
                            }

                            var initialLength = component.questions.length;

                            component.data_set.data_points.forEach(function(
                                point
                            ) {
                                var question = {};

                                if (!point.initialFound && point.visible) {
                                    question.id = guid();
                                    question.question_type_id =
                                        point.question_type_id;
                                    question.section_id = component.section_id;
                                    question.sort_order = ++initialLength;
                                    point.sort_order = question.sort_order;
                                    question.name = point.name;
                                    question.label = point.label;
                                    question.label_position =
                                        typeof $scope.form != "undefined" &&
                                        $scope.form.label_position != null
                                            ? $scope.form.label_position
                                            : true;
                                    question.required = point.required;
                                    question.component_id = component.id;
                                    question.question_type =
                                        point.question_type;
                                    question.service = point.service;
                                    question.method = point.method;
                                    question.select_show = point.select_show;
                                    question.options = point.options;
                                    question.vertical = true;
                                    question.multiple = false;
                                    question.disabled = false;
                                    question.update_from_form =
                                        point.table_name != null ? true : false;
                                    question.share_files = false;
                                    question.ssn_setting = 0;
                                    question.masked_setting = false;
                                    question.file_upload_description = true;
                                    question.show_in_grid =
                                        point.question_type.encrypted == true
                                            ? 0
                                            : 1;
                                    question.data_point_id = point.id;
                                    question.data_point_code = point.code;
                                    question.data_point_table_name =
                                        point.table_name;
                                    question.attribute_id = point.attribute_id;
                                    question.compound_id = point.compound_id;
                                    question.instruction_text =
                                        point.instruction_text;
                                    question.point = point;

                                    if (
                                        point.name == "CTCSS Receive Tone" ||
                                        point.name == "CTCSS Transmit Frequency"
                                    ) {
                                        question.validation = {};
                                        question.validation.expression =
                                            "^[0-9]{3}\\.[0-9]{1}$";
                                        question.validation.expression_message =
                                            "Please enter the value in 999.9 format.";
                                    }

                                    component.questions.push(question);
                                    component.data_points.push(point);
                                }
                            });
                        }
                    };

                    $scope.foreignDataSetInit = function (component, set) {
                        component.data_points = [];

                        if (component.data_set_id == null) {
                            component.data_set = {};
                        } else {
                            component.data_set = set;

                            component.questions.forEach(function(question) {
                                component.data_set.data_points.forEach(function(
                                    data_point
                                ) {
                                    if (
                                        data_point.id ==
                                            question.data_point_id &&
                                        data_point.attribute_id ==
                                            question.attribute_id
                                    ) {
                                        data_point.sort_order =
                                            question.sort_order;
                                        question.point = data_point;
                                        component.data_points.push(data_point);
                                    }
                                });
                            });
                        }
                    };

                    $scope.foreignDataSetChange = function(
                        allow_add,
                        allow_edit,
                        question,
                        componentTypes
                    ) {
                        var old_data_points =
                            question.sub_components !== undefined &&
                            question.sub_components[0] !== undefined
                                ? question.sub_components[0].data_points
                                : null;
                        var old_questions =
                            question.sub_components !== undefined &&
                            question.sub_components[0] !== undefined
                                ? question.sub_components[0].questions
                                : null;

                        if (
                            (allow_add || allow_edit) &&
                            (old_data_points != null || old_questions != null)
                        ) {
                            // One or the other has already been selected, no need to re-load all the data points
                            question.sub_components[0].component_conditions = [];
                            if (allow_add) {
                                var condition = {
                                    id: guid(),
                                    component_id: question.sub_components[0].id,
                                    question_id: question.id,
                                    value: nullGuid(),
                                    and_flag: true,
                                    left_parenthesis: 0,
                                    right_parenthesis: 0,
                                    sort_order: 1,
                                    operator: "="
                                };
                                question.sub_components[0].component_conditions.push(
                                    condition
                                );
                            }
                            if (allow_edit) {
                                var guidCondition = {
                                    id: guid(),
                                    component_id: question.sub_components[0].id,
                                    question_id: question.id,
                                    value: nullGuid(),
                                    and_flag: allow_add ? false : true,
                                    left_parenthesis: 1,
                                    right_parenthesis: 0,
                                    sort_order: 2,
                                    operator: "<>"
                                };
                                question.sub_components[0].component_conditions.push(
                                    guidCondition
                                );
                                var nullCondition = {
                                    id: guid(),
                                    component_id: question.sub_components[0].id,
                                    question_id: question.id,
                                    value: null,
                                    and_flag: true,
                                    left_parenthesis: 0,
                                    right_parenthesis: 1,
                                    sort_order: 3,
                                    operator: "<>"
                                };
                                question.sub_components[0].component_conditions.push(
                                    nullCondition
                                );
                            }
                        } else if (allow_add || allow_edit) {
                            // First time clicking one
                            question.sub_components = [];
                            var component_type = {};
                            componentTypes.forEach(function(componentType) {
                                if (componentType.code == "dataset") {
                                    component_type = componentType;
                                }
                            });

                            var component = {
                                id: guid(),
                                section_id: question.section_id,
                                sort_order: question.sub_components.length,
                                parent_question_id: question.id,
                                questions: [],
                                data_points: [],
                                edit: true,
                                component_conditions: [],
                                limit_document_type_ids: null,
                                limit_position_ids: null,
                                limit_license_level_ids: null,
                                limit_vehicle_type_ids: null,
                                skill_question_ids: null,
                                skill_show_points: null,
                                skill_default: null
                            };

                            component.data_set_id =
                                question.point.foreign_data_set_id;
                            component.data_set =
                                question.point.foreign_data_set;
                            component.isForeignDataSet = true;

                            component.component_type_id = component_type.id;
                            component.component_type = component_type;

                            if (allow_add) {
                                var condition = {
                                    id: guid(),
                                    component_id: component.id,
                                    question_id: question.id,
                                    value: nullGuid(),
                                    and_flag: true,
                                    left_parenthesis: 0,
                                    right_parenthesis: 0,
                                    sort_order: 1,
                                    operator: "="
                                };
                                component.component_conditions.push(condition);
                            }
                            if (allow_edit) {
                                var guidCondition = {
                                    id: guid(),
                                    component_id: component.id,
                                    question_id: question.id,
                                    value: nullGuid(),
                                    and_flag: allow_add ? false : true,
                                    left_parenthesis: 1,
                                    right_parenthesis: 0,
                                    sort_order: 2,
                                    operator: "<>"
                                };
                                component.component_conditions.push(
                                    guidCondition
                                );
                                var nullCondition = {
                                    id: guid(),
                                    component_id: component.id,
                                    question_id: question.id,
                                    value: null,
                                    and_flag: true,
                                    left_parenthesis: 0,
                                    right_parenthesis: 1,
                                    sort_order: 3,
                                    operator: "<>"
                                };
                                component.component_conditions.push(
                                    nullCondition
                                );
                            }

                            var initialLength = 0;

                            component.data_set.data_points
                                .sort(sortObjectArray("sort_order"))
                                .forEach(function(point) {
                                    var question = {};

                                    if (point.visible) {
                                        question.id = guid();
                                        question.question_type_id =
                                            point.question_type_id;
                                        question.section_id =
                                            component.section_id;
                                        question.sort_order = ++initialLength;
                                        point.sort_order = question.sort_order;
                                        question.name = point.name;
                                        question.label = point.label;
                                        question.label_position =
                                            typeof $scope.form != "undefined" &&
                                            $scope.form.label_position != null
                                                ? $scope.form.label_position
                                                : true;
                                        question.required = point.required;
                                        question.component_id = component.id;
                                        question.question_type =
                                            point.question_type;
                                        question.update_from_form =
                                            point.table_name != null
                                                ? true
                                                : false;
                                        question.service = point.service;
                                        question.method = point.method;
                                        question.select_show =
                                            point.select_show;
                                        question.options = point.options;
                                        question.point = point;
                                        question.data_point_id = point.id;
                                        question.data_point_code = point.code;
                                        question.data_point_table_name =
                                            point.table_name;
                                        question.attribute_id =
                                            point.attribute_id;
                                        question.compound_id =
                                            point.compound_id;

                                        if (
                                            point.name ==
                                                "CTCSS Receive Tone" ||
                                            point.name ==
                                                "CTCSS Transmit Frequency"
                                        ) {
                                            question.validation = {};
                                            question.validation.expression =
                                                "^[0-9]{3}\\.[0-9]{1}$";
                                            question.validation.expression_message =
                                                "Please enter the value in 999.9 format.";
                                        }

                                        component.questions.push(question);
                                        component.data_points.push(point);
                                    }
                                });
                            question.sub_components.push(component);
                        } else {
                            // Both deselected
                            question.sub_components = [];
                        }
                    };

                    $scope.dataPointChange = function(component) {
                        component.questions = [];

                        component.data_points.forEach(function(point) {
                            var setProperties = true;
                            var question = {};

                            if (
                                component.initialQuestions != null &&
                                component.initialQuestions[
                                    component.component_type_id
                                ] != null
                            ) {
                                component.initialQuestions[
                                    component.component_type_id
                                ].forEach(function(initialQuestion) {
                                    if (
                                        initialQuestion.data_point_id ==
                                            point.id &&
                                        point.attribute_id ==
                                            initialQuestion.attribute_id
                                    ) {
                                        question = initialQuestion;
                                        setProperties = false;
                                    }
                                });
                            }

                            if (setProperties) {
                                question.id = guid();
                                question.required = point.required;
                                question.name = point.name;
                                question.label = point.label;
                                question.label_position =
                                    typeof $scope.form != "undefined" &&
                                    $scope.form.label_position != null
                                        ? $scope.form.label_position
                                        : true;
                                question.question_type_id =
                                    point.question_type_id;
                                question.section_id = component.section_id;
                                question.sort_order = point.sort_order;
                                question.component_id = component.id;
                                question.question_type = point.question_type;
                                question.service = point.service;
                                question.method = point.method;
                                question.select_show = point.select_show;
                                question.options = point.options;
                                question.vertical = true;
                                question.multiple = false;
                                question.disabled = false;
                                question.update_from_form =
                                    point.table_name != null ? true : false;
                                question.share_files = false;
                                question.ssn_setting = 0;
                                question.masked_setting = false;
                                question.file_upload_description = true;
                                question.show_in_grid =
                                    point.question_type.encrypted == true
                                        ? 0
                                        : 1;
                                question.data_point_id = point.id;
                                question.data_point_code = point.code;
                                question.data_point_table_name =
                                    point.table_name;
                                question.attribute_id = point.attribute_id;
                                question.compound_id = point.compound_id;
                                question.instruction_text =
                                    point.instruction_text;
                            }

                            question.point = point;
                            if (
                                point.name == "CTCSS Receive Tone" ||
                                point.name == "CTCSS Transmit Frequency"
                            ) {
                                question.validation = {};
                                question.validation.expression =
                                    "^[0-9]{3}\\.[0-9]{1}$";
                                question.validation.expression_message =
                                    "Please enter the value in 999.9 format.";
                            }
                            component.questions.push(question);
                        });
                    };

                    $scope.limitPositionsChange = function (component) {
                        if (component.limit_position_ids_array != null) {
                            component.limit_position_ids = null;

                            component.limit_position_ids_array
                                .sort()
                                .forEach(function(position) {
                                    if (component.limit_position_ids == null) {
                                        component.limit_position_ids =
                                            position.id;
                                    } else {
                                        component.limit_position_ids +=
                                            "," + position.id;
                                    }
                                });

                            component.parameters.limit_position_ids =
                                component.limit_position_ids;
                        }
                        // get positions question and let it know to refresh its values
                        var question = getByAttr(
                            component.questions,
                            "data_point_code",
                            "service_users_position"
                        );
                        if (question != null) {
                            question.refreshOptions =
                                component.limit_position_ids;
                        }
                    };

                    $scope.limitLicenseLevelChange = function (component) {
                        if (component.limit_license_level_ids_array != null) {
                            component.limit_license_level_ids = null;

                            component.limit_license_level_ids_array
                                .sort()
                                .forEach(function (licenseLevel) {
                                    if (component.limit_license_level_ids == null) {
                                        component.limit_license_level_ids =
                                            licenseLevel.id;
                                    } else {
                                        component.limit_license_level_ids +=
                                            "," + licenseLevel.id;
                                    }
                                });

                            component.parameters.limit_license_level_ids =
                                component.limit_license_level_ids;
                        }
                    };

                    $scope.limitServiceClsfDisplayChange = function (component) {
                        if (component.service_classification_filter_ids_array != null) {
                            component.service_classification_filter_ids = null;

                            component.service_classification_filter_ids_array
                                .sort()
                                .forEach(function (service_classification) {
                                    if (component.service_classification_filter_ids == null) {
                                        component.service_classification_filter_ids =
                                            service_classification.id;
                                    } else {
                                        component.service_classification_filter_ids +=
                                            "," + service_classification.id;
                                    }
                                });

                            component.parameters.service_classification_filter_ids =
                                component.service_classification_filter_ids;
                        }
                    }

                    $scope.limitVehicleTypesChange = function (component) {
                        if (component.limit_vehicle_type_ids_array != null) {
                            component.limit_vehicle_type_ids = null;

                            component.limit_vehicle_type_ids_array
                                .sort()
                                .forEach(function (vehicle_types) {
                                    if (component.limit_vehicle_type_ids == null) {
                                        component.limit_vehicle_type_ids =
                                            vehicle_types.id;
                                    } else {
                                        component.limit_vehicle_type_ids +=
                                            "," + vehicle_types.id;
                                    }
                                });

                            component.parameters.limit_vehicle_type_ids =
                                component.limit_vehicle_type_ids;
                        }
                        // get service_vehicle_type_restriction question and let it know to refresh its values
                        var question = getByAttr(
                            component.questions,
                            "data_point_code",
                            "service_vehicle_type_restriction"
                        );
                        if (question != null) {
                            question.refreshOptions =
                                component.limit_vehicle_type_ids;
                        }
                    };

                    $scope.limitDocumentTypesChange = function (component) {
                        if (component.limit_document_type_ids_array != null) {
                            component.limit_document_type_ids = null;

                            component.limit_document_type_ids_array
                                .sort()
                                .forEach(function (document_types) {
                                    if (component.limit_document_type_ids == null) {
                                        component.limit_document_type_ids =
                                            document_types.id;
                                    } else {
                                        component.limit_document_type_ids +=
                                            "," + document_types.id;
                                    }
                                });

                            component.parameters.limit_document_type_ids =
                                component.limit_document_type_ids;
                        }
                        // get service_document_type_restriction question and let it know to refresh its values
                        var question = getByAttr(
                            component.questions,
                            "data_point_code",
                            "service_financials_supporting_documents"
                        );
                        if (question != null) {
                            question.refreshOptions =
                                component.limit_document_type_ids;
                        }
                    };

                    $scope.conditionalChange = function (component) {
                        if (component.conditional) {
                            component.component_conditions.push({
                                id: guid(),
                                and_flag: true,
                                operator: "=",
                                left_parenthesis: 0,
                                right_parenthesis: 0,
                                sort_order: 1
                            });
                        } else {
                            component.component_conditions = [];
                        }
                    };

                    $scope.formElementChange = function(
                        component,
                        form_elements
                    ) {
                        form_elements.forEach(function(element) {
                            if (element.id == component.element_id) {
                                component.element_code = element.code;
                                component.element_instructions =
                                    element.description;
                            }
                        });
                    };

                    $scope.allowMultipleGroupChange = function(component) {
                        component.update_from_form_update = false;
                        component.update_from_form_delete = false;
                    };
                
                    $scope.showShareFiles = function(component) {
                        var show = false;

                        if (
                            component.questions.length == 1 &&
                            component.questions[0].question_type != null &&
                            component.questions[0].question_type.code ==
                                "file_upload"
                        ) {
                            show = true;
                        } else {
                            component.share_files = false;
                        }

                        return show;
                    };

                    $scope.revertElement = function(element) {
                        angular.copy(element.original, element);
                        element.edit = false;
                    };

                    // Ckeditor Setup
                    $scope.cke_skin = 'bootstrapck';
                }
            ],
            replace: true,
            transclude: true,
            templateUrl:
                "templates/form-builder/form-builder-component/form-builder-component.html",
            link: function(scope, elem, attrs, ctrl) {}
        };
    }
]);
